import { Injectable, signal } from '@angular/core'
import { RootInjectorGuard } from '../guards/root-injector.guard'

@Injectable({
  providedIn: 'root',
})
export class NavbarService extends RootInjectorGuard {
  public shouldShowNavBar = signal(true)

  constructor() {
    super(NavbarService)
  }

  /**
   * Sets header-navbar (navbar with search) to visible
   */
  showNavBar() {
    this.shouldShowNavBar.set(true)
  }

  /**
   * Sets header-navbar (navbar with search) to not visible
   */
  hideNavBar() {
    this.shouldShowNavBar.set(false)
  }
}
